import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Spinner from "../../Components/Spinner";
import regionDisplayNames from "../../JSON/AzureDisplayNames.json"
import FormatDateTime from "../../Functions/FormatDate";
import CanvasAnimation from "../../Components/CanvasItems";

const LoadingClusterCreation = () => {
    const { clus_id, project_id } = useParams();
    const navigate = useNavigate();
    const user_id = sessionStorage.getItem("user_id");

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [clusterData, setClusterData] = useState(null);
    const [loadingSecond, setLoadingSecond] = useState(false)
    useEffect(() => {
        let interval;

        const fetchRecords = async () => {
            try {
                const response = await fetch("https://backend.erioon.com/get_specific_cluster", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ user_id, clus_id }),
                });

                if (response.ok) {
                    const result = await response.json();
                    const data = result.cluster || {};
                    setClusterData(data);
                    setError(false);
                    setLoading(false);
                    return data.status;
                } else {
                    setError(true);
                    setLoading(false);
                }
            } catch (err) {
                console.error(err);
                setError(true);
                setLoading(false);
            }
        };

        const startPolling = async () => {
            const status = await fetchRecords();

            if (status !== "running") {
                setLoadingSecond(true)
                interval = setInterval(async () => {
                    const newStatus = await fetchRecords();
                    if (newStatus === "running") {
                        clearInterval(interval);
                    }
                }, 5000);
            } else {
                setLoadingSecond(false)
            }
        };

        startPolling();
        return () => clearInterval(interval);
    }, [user_id, clus_id]);


    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error fetching cluster data.</p>;

    return (
        <div className="loading_cluster_creation">

            {clusterData?.status === "running" && clusterData?.cluster_az_data ? (
                <>
                    <p className="loading_cluster_creation_mex">
                        {clusterData?.k8sname || "Unnamed"} is ready!
                    </p>
                    <p className="loading_cluster_creation_submex">Your cluster has been deployed successfully!</p>
                </>

            ) : clusterData?.status === "failed" ? (
                <>
                    <p className="loading_cluster_creation_mex">
                        {clusterData?.k8sname || "Unnamed"} failed to deploy
                    </p>
                    <p className="loading_cluster_creation_submex">Please retry to deploy the cluster...</p>
                </>
            ) : clusterData?.status === "updating" ? (
                <>
                    <p className="loading_cluster_creation_mex">
                        {clusterData?.k8sname || "Unnamed"} is being scaled
                    </p>
                    <p className="loading_cluster_creation_submex">Please hold on, it will take a few seconds...</p>
                </>
            ): (
                <>
                    <p className="loading_cluster_creation_mex">
                        {clusterData?.k8sname || "Unnamed"} is being created
                    </p>
                    <p className="loading_cluster_creation_submex">Please hold on, it will take a few minutes...</p>
                </>
            )}

            <div className={`cluster_card_data ${clusterData?.status ? `cluster_card_data_${clusterData.status}` : ""}`}>
                <p className="cluster_card_item">Cluster ID <span className="cluster_card_dynamic_p">{clusterData?._id || "N/A"}</span></p>
                <p className="cluster_card_item">Cluster Name <span className="cluster_card_dynamic_p">{clusterData?.k8sname || "N/A"}</span></p>
                <p className="cluster_card_item">Description <span className="cluster_card_dynamic_p">{clusterData?.clus_desc || "N/A"}</span></p>
                <p className="cluster_card_item">Location <span className="cluster_card_dynamic_p">{regionDisplayNames[clusterData?.selectedRegion]}</span></p>
                <p className="cluster_card_item">Nodes <span className="cluster_card_dynamic_p">{clusterData?.nodes || "N/A"}</span></p>
                <p className="cluster_card_item">OS Type <span className="cluster_card_dynamic_p">{clusterData?.osType || "N/A"}</span></p>
                <p className="cluster_card_item">VM Size <span className="cluster_card_dynamic_p">{clusterData?.vm_size || "N/A"}</span></p>
                <p className="cluster_card_item">Creation date <span className="cluster_card_dynamic_p">{FormatDateTime(clusterData?.timestamp)}</span></p>
                <p className="cluster_card_item">Pool name <span className="cluster_card_dynamic_p">{clusterData?.agent_pool_name || "N/A"}</span></p>
                <p className="cluster_card_item">Status
                    <span className="cluster_card_dynamic_p">
                        {clusterData?.status == "running" ? (
                            <>Running</>
                        ) : clusterData?.status == "loading" ? (
                            <><Spinner loading={loadingSecond} /></>

                        ) : clusterData?.status == "updating" ? (
                            <>Updating <Spinner loading={loadingSecond} /></>

                        ) : (
                            <>Failed to create</>
                        )}
                    </span>
                </p>

                {clusterData?.status === "running" && clusterData?.cluster_az_data && (
                    <>
                        <p className="cluster_card_item">Cluster version <span className="cluster_card_dynamic_p">{clusterData.cluster_az_data.kubernetes_version}</span></p>

                        <button
                            className="save_btn_db"
                            onClick={() => navigate(`/project_panel/${project_id}/clusters/${clus_id}/analytics`)}
                        >
                            Open resource
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default LoadingClusterCreation;
